import React from 'react';

import type { CardMediaOverlayProps } from './Card.types';
import clsx from 'clsx';

export const CardMediaOverlay = React.forwardRef<
  HTMLElement,
  CardMediaOverlayProps
>(({ as: Component = 'div', className, testId, theme, ...restProps }, ref) => {
  return (
    <Component
      {...restProps}
      ref={ref}
      data-theme={theme}
      data-testid={testId}
      className={clsx('hg-card__media-overlay', className)}
    />
  );
});

CardMediaOverlay.displayName = 'Card.MediaOverlay';
